module.exports = __webpack_public_path__ + "img/中国电科-1.08d99de5.png";